import { __assign } from '../../../../../../../../node_modules/tslib/tslib.es6.js';
import { Box, Typography } from '@mui/material';
import React__default from 'react';
import { Check } from '@mui/icons-material';

var SelectFilter = function (_a) {
    var filter = _a.filter, onChange = _a.onChange, mobile = _a.mobile;
    var label = filter.label, options = filter.options, value = filter.value, id = filter.id;
    return (React__default.createElement(Box, { display: "flex", flexDirection: "column" },
        label && (React__default.createElement(Typography, { component: "div", pb: 1, id: "filter-select-".concat(id, "__label") }, label)),
        options.map(function (option, i) { return (React__default.createElement(Box, { display: "flex", paddingY: mobile ? "7px" : "6px", key: option.value, onClick: function () { return onChange(__assign(__assign({}, filter), { value: option.value })); }, id: "filter-select-".concat(id, "__option-").concat(i) },
            React__default.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", flex: 1, color: value === option.value ? "highlighted" : "neutral300", sx: { cursor: "pointer" } },
                React__default.createElement(Typography, { color: "inherit", variant: mobile ? "body2" : "body1", lineHeight: "24px" }, option.label),
                value === option.value && React__default.createElement(Check, null)))); })));
};

export { SelectFilter as default };
